/**
 * Sendungsverfolgung im Browser.
 *
 * Dieselbe Liste wie im Server, absichtlich doppelt: Der Verweis soll ohne
 * Rückfrage stehen, sobald eine Nummer sichtbar wird. Ändert sich eine Adresse,
 * sind es zwei Stellen — dafür braucht keine Liste geladen zu werden, nur um
 * einen Verweis zu zeichnen.
 */
const VERSENDER: Record<string, { name: string; verfolgung: string | null }> = {
  dhl: {
    name: 'DHL Paket',
    verfolgung: 'https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?piececode={nr}',
  },
  'dhl-express': {
    name: 'DHL Express',
    verfolgung: 'https://www.dhl.com/de-de/home/tracking/tracking-express.html?tracking-id={nr}',
  },
  dpd: { name: 'DPD', verfolgung: 'https://tracking.dpd.de/status/de_DE/parcel/{nr}' },
  gls: { name: 'GLS', verfolgung: 'https://gls-group.com/DE/de/paketverfolgung?match={nr}' },
  ups: { name: 'UPS', verfolgung: 'https://www.ups.com/track?loc=de_DE&tracknum={nr}' },
  fedex: { name: 'FedEx', verfolgung: 'https://www.fedex.com/fedextrack/?trknbr={nr}' },
  hermes: {
    name: 'Hermes',
    verfolgung: 'https://www.myhermes.de/empfangen/sendungsverfolgung/sendungsinformation/#{nr}',
  },
  post: {
    name: 'Deutsche Post',
    verfolgung: 'https://www.deutschepost.de/sendung/simpleQueryResult.html?form.sendungsnummer={nr}',
  },
  spedition: { name: 'Spedition', verfolgung: null },
  selbstabholer: { name: 'Selbstabholer', verfolgung: null },
};

export function verfolgungsLink(carrier: string | null, nummer: string | null): string | null {
  if (!carrier || !nummer) return null;
  const eintrag = VERSENDER[carrier.trim().toLowerCase()];
  if (!eintrag?.verfolgung) return null;
  return eintrag.verfolgung.replace('{nr}', encodeURIComponent(nummer.trim()));
}

export function versenderName(carrier: string | null): string | null {
  if (!carrier) return null;
  return VERSENDER[carrier.trim().toLowerCase()]?.name ?? carrier;
}
